export default {
    state: {
        personalData: {
            instituicao: {},
            login: '',
            senha: '',
            nome: '',
            cpf: '',
            email: '',
            telefone: '',
            celular: ''
        },
        addressData: {
            endereco: '',
            cep: '',
            numero: '',
            complemento: '',
            referencia: '',
            uf: {},
            municipio: {},
            bairro: ''
        },
        dependentsData: []
    },
    mutations: {
        setPersonalData (state, data) {
            state.personalData[data.id] = data.value
        },
        addDependentsData (state, data) {
            state.dependentsData.push(data)
        },
        setDependentsData (state, data) {
            state.dependentsData = data
        },
        setPersonalInstituicaoData (state, data) {
            state.personalData.instituicao = data
        },
        setAddressUfData (state, data) {
            state.addressData.uf = data
        },
        setAddressCitieData (state, data) {
            state.addressData.municipio = data
        },
        setAddressData (state, data) {
            state.addressData[data.id] = data.value
        },
        clearAllData (state) {
            state.personalData = {
                instituicao: {},
                login: '',
                senha: '',
                nome: '',
                cpf: '',
                email: '',
                telefone: '',
                celular: ''
            }
            state.addressData = {
                endereco: '',
                cep: '',
                numero: '',
                complemento: '',
                referencia: '',
                uf: {},
                municipio: {},
                bairro: ''
            }
            state.dependentsData = []
        }
    },
    actions: {
        setPersonalData ({ commit }, data) {
            commit('setPersonalData', data)
        },
        addDependentsData ({ commit }, data) {
            commit('addDependentsData', data)
        },
        setDependentsData ({ commit }, data) {
            commit('setDependentsData', data)
        },
        setPersonalInstituicaoData ({ commit }, data) {
            commit('setPersonalInstituicaoData', data)
        },
        setAddressUfData ({ commit }, data) {
            commit('setAddressUfData', data)
        },
        setAddressCitieData ({ commit }, data) {
            commit('setAddressCitieData', data)
        },
        setAddressData ({ commit }, data) {
            commit('setAddressData', data)
        },
        clearAllData ({ commit }) {
            commit('clearAllData')
        }
    },
    getters: {
        getPersonalData: (state) => state.personalData,
        getAddressData: (state) => state.addressData,
        getDependentsData: (state) => state.dependentsData,
        getAllData: (state) => state
    }
}
